module.exports = __webpack_public_path__ + "static/media/immaculateheartofmary.f652e519.jpg";